/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbSharedRelatedCreators_itemSearch = {
    readonly meta: {
        readonly attributeDisplayName: string | null;
    } | null;
    readonly topCategoryL1: VerticalType | null;
    readonly relatedCreators: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly linkData: {
                    readonly path: string | null;
                };
                readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedCreator_relatedCreators">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedFollowSearchProvider_itemSearch">;
    readonly " $refType": "SbSharedRelatedCreators_itemSearch";
};
export type SbSharedRelatedCreators_itemSearch$data = SbSharedRelatedCreators_itemSearch;
export type SbSharedRelatedCreators_itemSearch$key = {
    readonly " $data"?: SbSharedRelatedCreators_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRelatedCreators_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedCreators_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attributeDisplayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topCategoryL1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "relatedCreatorsConnection",
      "kind": "LinkedField",
      "name": "relatedCreators",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "relatedCreatorsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RelatedCreatorType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "kind": "LinkedField",
                  "name": "linkData",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "path",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SbSharedRelatedCreator_relatedCreators"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '973302aac183c23b00e85cb50bcce0c3';
export default node;
